/*
 * Copyright (c) 2019. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import FeesService from "../FeesService";
import { AbstractCase } from "../../types/Entities/AbstractCase";
import dayjs from "dayjs";

class CostCalculator {
  static settlementValue(settlement: AbstractCase) {
    return Math.round(dayjs().diff(dayjs(settlement.employedSince), "days") / 365) * settlement.grossSalary * 0.5;
  }

  static calculateValueInDispute(settlement: AbstractCase) {
    return settlement.grossSalary * 3;
  }

  static getProcessCost(valueInDispute: number, addVat = true) {
    return FeesService.getFeeByValue(valueInDispute, 1.3, addVat);
  }

  static getHearingCost(valueInDispute: number, addVat = true) {
    return FeesService.getFeeByValue(valueInDispute, 1.2, addVat);
  }

  static getSettlementCost(valueInDispute: number, addVat = true) {
    return FeesService.getFeeByValue(valueInDispute, 1.0, addVat);
  }

  static getCourtCosts(valueInDispute: number) {
    return FeesService.getCourtCosts(valueInDispute, 2.0);
  }

  static getFullCosts(valueInDispute: number, addVat = true) {
    return (
      this.getProcessCost(valueInDispute, addVat) +
      this.getHearingCost(valueInDispute, addVat) +
      FeesService.getExpenses(addVat)
    );
  }
}

export default CostCalculator;
